import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60fffc8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll q-px-lg q-gutter-y-sm justify-center" }
const _hoisted_2 = { class: "q-px-lg q-my-lg flex justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_empty_placeholder = _resolveComponent("empty-placeholder")!
  const _component_qs_lead_display = _resolveComponent("qs-lead-display")!
  const _component_qs_company_display = _resolveComponent("qs-company-display")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_input, _mergeProps({
          loading: _ctx.loadingOptions,
          placeholder: _ctx.t('SEARCH_PLACEHOLDER'),
          class: "full-width",
          maxlength: "250",
          ref: "leadQuickSearch"
        }, _ctx.INPUT_LG, {
          modelValue: _ctx.searchInput,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event)),
            _ctx.searchOptions
          ],
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.goToSearch()), ["enter"]))
        }), {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: _ctx.ICONS_NAME.SEARCH_OUTLINE
            }, null, 8, ["name"])
          ]),
          _: 1
        }, 16, ["loading", "placeholder", "modelValue", "onUpdate:modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_q_item_label, _mergeProps({ class: "q-px-lg q-mb-sm" }, _ctx.TEXT_CARD_BODY), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.searchInput.length < 3 ? _ctx.t('RECENT_LABEL') : _ctx.t('QUICK_SEARCH_LABEL')), 1)
      ]),
      _: 1
    }, 16),
    _createElementVNode("div", _hoisted_1, [
      ((_ctx.options?.length ?? 0) === 0)
        ? (_openBlock(), _createBlock(_component_empty_placeholder, {
            key: 0,
            size: "md",
            message: _ctx.t(`EMPTY.QUICK_SEARCH.${_ctx.searchInput.length < 3 ? 'RECENT' : 'FILTERED'}.MESSAGE`),
            hint: _ctx.t(`EMPTY.QUICK_SEARCH.${_ctx.searchInput.length < 3 ? 'RECENT' : 'FILTERED'}.HINT`, { leads: _ctx.t('LEAD.LOW.PLUR') })
          }, null, 8, ["message", "hint"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (option['@type'] === _ctx.DataType.Lead)
            ? (_openBlock(), _createBlock(_component_qs_lead_display, {
                key: 0,
                data: option,
                index: index,
                "search-input": _ctx.searchInput
              }, null, 8, ["data", "index", "search-input"]))
            : (option['@type'] === _ctx.DataType.PrivateCompany)
              ? (_openBlock(), _createBlock(_component_qs_company_display, {
                  key: 1,
                  data: option,
                  index: index,
                  "search-input": _ctx.searchInput
                }, null, 8, ["data", "index", "search-input"]))
              : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createVNode(_component_q_separator),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.t('QUICK_ACTION')), 1),
      _createVNode(_component_q_btn, _mergeProps({
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToSearch()))
      }, _ctx.BTN_PRIMARY_MD), {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: _ctx.ICONS_NAME.FILTER_OUTLINE
          }, null, 8, ["name"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t('ADVANCED_SEARCH')), 1)
        ]),
        _: 1
      }, 16)
    ])
  ], 64))
}